import {useContext} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';

import AppContext from '../context/AppContext';

type ProtectedRouteProps = {
  isAllowed: boolean;
  redirectTo?: string;
};

const ProtectedRoute = ({isAllowed, redirectTo = '/unauthorized'}: ProtectedRouteProps) => {
  const {user} = useContext(AppContext);
  const loc = useLocation();

  if (!user) {
    console.log('user', user);
    return <Navigate to={`/login?to=${loc.pathname}`} replace />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
